import { useEffect, useState } from 'react';

const useNearBottom = (offset = 100) => {
    const [isNearBottom, setIsNearBottom] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const windowHeight = window.innerHeight;
            const fullHeight = document.documentElement.scrollHeight;

            const nearBottom = scrollTop + windowHeight >= fullHeight - offset;
            setIsNearBottom(nearBottom);
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll(); // Llamada inicial

        return () => window.removeEventListener('scroll', handleScroll);
    }, [offset]);

    return isNearBottom;
};

export default useNearBottom;
